module.exports = __webpack_public_path__ + "img/4f655f0.jpg";